module.exports = __webpack_public_path__ + "static/media/test.2f2152cf.gif";